import React, { Fragment } from 'react';
import * as R from 'ramda';
import { Icon } from 'antd';
import { array, func, string } from 'prop-types';
import { withState, mapProps, withHandlers, compose } from 'recompose';

import {
  UserRow,
  UserInfo,
  UserIcon,
  AssignBtn,
  SearchInput,
  UsersListWrapper,
} from './styled-components';

import { getAvatarUrl, sortDataByAlphabet } from '../../../../../utils';

const enhancer = compose(
  withState('searchValue', 'setSearchValue', ''),
  mapProps(({
    users,
    followers,
    searchValue,
    currentUserId,
    ...rest
  }) => {
    const usersList = sortDataByAlphabet('fullName', Object.values(users)).filter((item) => {
      if (item._id === currentUserId) {
        return false;
      }

      return item.isActivated
        && !item.isDeleted
        && !followers.find(follower => follower === item._id);
    });
    const filteredUsers = usersList.filter(({ fullName }) =>
      fullName.toLowerCase().includes(searchValue.trim().toLowerCase()));
    return {
      ...rest,
      usersList,
      searchValue,
      filteredUsers,
    };
  }),
  withHandlers({
    onSearchUser: ({ setSearchValue }) => ({ value }) => setSearchValue(value),
    clearInput: ({ setSearchValue }) => () => setSearchValue(''),
  }),
);

function SearchAssignees({
  searchValue,
  onSearchUser,
  filteredUsers,
  onAddAssignee,
  clearInput,
}) {
  return (
    <Fragment>
      <SearchInput
        placeholder="Type User's Full Name..."
        suffix={<Icon type="search" />}
        value={searchValue}
        onChange={({ target }) => onSearchUser(target)}
      />
      {!R.isEmpty(filteredUsers) ? (
        <UsersListWrapper
          onClick={(e) => { e.stopPropagation(); }}
        >
          {
            sortDataByAlphabet('fullName', filteredUsers).map(({ _id, fullName, profileImage }, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <UserRow key={i}>
                <UserInfo>
                  <UserIcon
                    src={getAvatarUrl(profileImage)}
                    style={{ cursor: 'default' }}
                  />
                  <span>{fullName}</span>
                </UserInfo>
                <AssignBtn
                  style={{ marginRight: '10px' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onAddAssignee(_id);
                    clearInput();
                  }}
                >
                  + Assign
                </AssignBtn>
              </UserRow>
            ))
          }
        </UsersListWrapper>
      ) : (
        <UserRow style={{ justifyContent: 'center' }}>
          No results...
        </UserRow>
      )}
    </Fragment>
  );
}

SearchAssignees.propTypes = {
  onSearchUser: func.isRequired,
  searchValue: string.isRequired,
  onAddAssignee: func.isRequired,
  filteredUsers: array.isRequired,
  clearInput: func.isRequired,
};


export default enhancer(SearchAssignees);



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/manage-assignees/search-assignees.js